import { z } from 'zod';
export const CreateShareRequest = z.object({
    rootAlbumId: z.string().min(1),
    recipientUserId: z.string().min(1),
    wrappedAlbumKey: z.string().min(1),
});
export const Share = z.object({
    rootAlbumId: z.string(),
    recipientUserId: z.string(),
    ownerId: z.string(),
    wrappedAlbumKey: z.string(),
    // Generation of K_album that wrappedAlbumKey decrypts to. Pre-rotation
    // shares default to gen 1 (absent → 1). Used by the viewer to detect
    // rotation: if photo.keyGen != share.keyGen the photo is unreadable.
    keyGen: z.number().int().positive().optional(),
    // Set only while a key rotation is in progress on the owner's root and the
    // owner has chosen to keep this recipient. Cleared (swapped into
    // wrappedAlbumKey) by rotate-commit.
    wrappedAlbumKeyNext: z.string().optional(),
    permissions: z.literal('read'),
    grantedAt: z.string(),
});
// Incoming share (viewer perspective): shows the *owner* (sender) email so the
// viewer knows who shared the album. wrappedAlbumKey is wrapped for the
// caller's rsaPub and is needed to unwrap K_album client-side.
export const IncomingShare = Share.extend({
    ownerEmail: z.string().email(),
});
export const IncomingSharesResponse = z.object({
    shares: z.array(IncomingShare),
});
// Outgoing share (owner perspective): shows the *recipient* email so the owner
// can identify who they shared with. wrappedAlbumKey is wrapped for the
// recipient and is opaque to the owner — included only for completeness.
// During rotation, wrappedAlbumKeyNext (inherited from Share) is set for
// recipients the owner has chosen to keep — useful for the rotate UI to show
// keep/revoke state at a glance.
export const OutgoingShare = Share.extend({
    recipientEmail: z.string().email(),
});
export const OutgoingSharesResponse = z.object({
    shares: z.array(OutgoingShare),
});
export const CreateShareResponse = Share;
//# sourceMappingURL=share.js.map